// @flow
import React from 'react';
import styled from 'styled-components';
import moment from 'moment'
import colors from '../common/components/ui/colors';
import { formatPrice } from '../../utils/price-utils';
import { TimeButton } from '../../modules/pros/components/TimeButton';
import withLocalized from '../localization/withLocalized';
import { renderDiscountPrice } from "./components/DiscountedPrice";

const StyledWrapper = styled.section`
  border: 1px solid #a7a7a7;
  border-radius: 2px;
  margin-bottom: 1.5rem;
  overflow: hidden;
`;

const StyledHeader = styled.header`
  display: flex;
  border-bottom: 1px solid #a7a7a7;
  align-items: center;
`;

const Figure = styled.figure`
  background: white;
  ${props => props.src && (`
    background-image: url(${props.src});
    background-position: 50% 50%;
    background-size: cover;
  `
)}
  width: 58px;
  height: 58px;
  overflow: hidden;
  display: flex;
  align-items: center;
  flex-grow: 0;
  flex-shrink: 0;
  align-self: flex-start;
`;

const StyledThumbnail = styled(({src, ...rest}) => {
  return (
    <Figure src={src}  {...rest} />
  );
})``;

const StyledTitle = styled.div`
  flex: 1;
  padding: 0 1rem;
  line-height: 1.2em;
  
  p {
    color: #969696;
    margin: 0;
    strong {
      color: ${colors.BRAND_GREEN};
    }
  }
`;

const StyledDescription = styled.div`
  padding: 0.75rem 1rem;
  font-size: ${14/16}rem;
  line-height: 1.2em;
  p {
    margin-bottom: 1em;
  }
`;

const DateTitle = styled.h3`
  font-size: 1.5rem;
  line-height: 1.6em;
  color: ${colors.BRAND_GREEN};
  margin-top: .75rem;
  margin-bottom: 1rem;
  text-align: center;
  text-transform: uppercase;
`;

const ServiceDescription = styled.p`
  font-size: 1rem;
  line-height: ${20/16}rem;
  // color: ${colors.BRAND_GREEN};
  margin-bottom: 0;
  text-align: center;
`;

const getEndTimeForReservationBlock = (block, service) => {
  return moment(block).add(service.duration, 'minutes').format('HH.mm');
};

const SetsterBookingDetails = ({service, reservation, pro, localeConfig, price}: {service:Object, reservation:Object, pro:Object}) => {
  const {
    default_currency = 'EUR'
  } = pro;
  const { name, description } = service;
  const reservationItem = reservation[0]; // first we only deal with single items, additional products to be added

  const imageSrc = 'https://app.birdietime.com/sites/default/files/styles/large/public/2017-04/bt2060b-noshd_47.jpg?itok=NTNskIyN';
  const reservationDate = reservationItem.format('dddd D.M.');
  const reservationStartTime = reservationItem.format('HH.mm');
  const reservationEndTime = getEndTimeForReservationBlock(reservationItem, service);
  const formattedPrice = formatPrice(price.price_value, default_currency, localeConfig('units.currency.locale'));

  let location = '';
  pro.services.forEach(_service => {
    _service.service_types.forEach(type => {
      if (type.service_id === service.id) {
        location = _service.related_golf_course[0].label;
      }
    });
  });

  return (
    <StyledWrapper>

      <StyledHeader>
        {imageSrc && (
          <StyledThumbnail src={imageSrc} role="presentation" />
        )
        }
        <StyledTitle>
          <p>
            <strong>{ name }</strong><br />
            { location }
          </p>
        </StyledTitle>
      </StyledHeader>


      <StyledDescription>

        <DateTitle>
          { reservationDate }
        </DateTitle>

        <TimeButton className="disable-hover">
          <span className="time">
            {`${reservationStartTime} - ${reservationEndTime}`}
          </span>
          { renderDiscountPrice(price, localeConfig) }
          <span className="price">
            { formattedPrice }
          </span>
        </TimeButton>

        <ServiceDescription>
          { description }
        </ServiceDescription>

      </StyledDescription>
    </StyledWrapper>
  );
};

export default withLocalized(SetsterBookingDetails);



// WEBPACK FOOTER //
// ./src/modules/booking/SetsterBookingDetails.js